import React from 'react';

interface IRenderTitleProps {
  titleSize?: number;
  tipSize?: number;
  title: string;
  tips?: string;
}

export default function RenderTitle(props: IRenderTitleProps) {
  const { titleSize = 22, tipSize = 14, title, tips } = props;
  return (
    <div className="dbo-card-title">
      <span className='dbo-card-titles' style={{fontSize: titleSize}}>{title}</span>
      <span className='dbo-card-title-sub' style={{fontSize: tipSize}}>&nbsp;&nbsp;{tips}</span>
    </div>
  );
}